import script from "./restricted.vue?vue&type=script&setup=true&lang=js"
export * from "./restricted.vue?vue&type=script&setup=true&lang=js"

import "./restricted.vue?vue&type=style&index=0&id=e592e204&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-e592e204"]])

export default __exports__